import React from 'react';

// Deps
import pull from 'lodash/pull'
import union from 'lodash/union'
import isEqual from 'lodash/isEqual'
// import extend from 'lodash/extend'
import omit from 'lodash/omit'
import pick from 'lodash/pick'
import validation from 'utils/validation'
import ReCAPTCHA from "react-google-recaptcha";
import config from 'config'
import Cleave from 'cleave.js/react';
// import 'cleave.js/dist/addons/cleave-phone.tr.js'
import 'cleave.js/dist/addons/cleave-phone.i18n.js'

// Wysiwyg
import { EditorState, convertToRaw } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import { stateFromHTML } from 'draft-js-import-html';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

// Functions
import uid from 'functions/uid'
import pxToRem from 'functions/px-to-rem'
import serializeForm from 'functions/serialize-form'
import serializeObject from 'functions/serialize-object'

// Partials
import Select from 'views/shared/partials/select'
import DatePicker from 'views/shared/partials/datepicker'

export class FormInput extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			error: false,
			touched: false,
			value: false,
			valid: false,
		}

		this.onChange = this.onChange.bind(this);
		this.validate = this.validate.bind(this);
		this.reset = this.reset.bind(this);

		this.input = React.createRef();
		this.id = (props.id ? props.id : uid('form_input'));
		this.name = (props.name ? props.name : (props.name === false ? undefined : this.id));
	}

	validate() {
		if (this.input.current) {
			this.input.current.validate();
		}
	}

	onChange(status) {
		if (this.props.onChangeInForm) {
			this.props.onChangeInForm({
				value: status.value,
				name: status.name,
				error: status.error,
				errorMessage: status.errorMessage,
				touched: status.touched,
				validation: status.validation,
			});
		}

		this.setState({
			error: status.error,
			touched: status.touched,
			value: status.value,
		});
	}

	reset() {
		if (this.input.current) {
			this.input.current.reset();
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if(this.props.onChange && !isEqual(this.state.value, prevState.value)) {
			this.props.onChange(this.state.value, this.props.name, this.state.error, this.state.touched);
		}
		if(this.props.formRef) {
			this.props.formRef(this);
		}

		if (this.props.validation !== false && this.state.error !== prevState.error) {
			this.setState({
				 valid: (this.state.value !== false && this.state.value !== null && !this.state.error)
			});
		}

		if(this.props.onValid && this.state.valid === true && prevState.valid !== true) {
			this.props.onValid(true);
		}
	}

	render() {
		let vm = this;

		let displayType = vm.props.type;
		switch(displayType) {
			case 'text':
			case 'password':
			case 'number':
			case 'email':
			case 'url':
			case 'phone':
				displayType = 'text';
			break;
			default:
			break;
		}

		let wrapClasses =
			"inputwrap type-" + displayType +
			(vm.props.className ? ' ' + vm.props.className : '') +
			((vm.state.touched || vm.props.forceTouch) && vm.state.error ? ' error' : '') +
			(vm.props.popLabel ? ' pop-label' : '') +
			(vm.props.label ? ' has-label' : '') +
			((vm.props.disabled || vm.props.readOnly) ? ' disabled' : '') +
			(vm.props.icon ? ' has-icon' : '') +
			(vm.props.block ? ' block' : '') +
			(vm.props.hollow ? ' hollow' : '') +
			(vm.props.big ? ' big' : '') +
			(vm.props.small ? ' small' : '') +
			(vm.props.z ? (' z-' + vm.props.z) : '') +
			((vm.state.value !== "" && vm.state.value !== false && vm.state.value !== null && vm.state.value !== undefined) ? ' input-full' : '') +
			// ((vm.props.validation !== false && !vm.props.noValidClass && vm.state.value !== "" && vm.state.value !== false && vm.state.value !== null && !vm.state.error) ? ' input-valid' : '');
			((vm.state.valid && !vm.props.noValidClass) ? ' input-valid' : '');

		let name = vm.name;

		let Input = false;
		let inputProps = {
			...omit(vm.props, ['id', 'onChangeInForm', 'forceTouch', 'onChange', 'className', 'formInput', 'name', 'big', 'noValidClass', 'hollow', 'z', 'formRef', 'onValid']),
			id: vm.id,
			name: name,
			onChange: vm.onChange,
			touched: (vm.props.forceTouch || vm.state.touched),
			className: wrapClasses,
		};

		switch (displayType) {
			case 'date':
				Input = InputDate;
				break;
			case 'checkbox':
				Input = (vm.props.options ? InputCheckGroup : InputCheck);
				break;
			case 'radio':
				Input = InputRadio;
			break;
			case 'file':
				Input = InputFile;
				if (inputProps.validation === true || inputProps.validation === false) {
					inputProps.validation = (inputProps.validation ? ['fileRequired'] : false);
				}
				else if (inputProps.validation === 'required') {
					inputProps.validation = ['fileRequired'];
				}
				else {
					let reqIndex = Array.isArray(inputProps) ? inputProps.validation.indexOf('required') : -1;
					if (reqIndex !== -1) {
						inputProps.validation[reqIndex] = 'fileRequired';
					}
				}
				break;
			case 'select':
				Input = InputSelect;
				break;
			case 'textarea':
				Input = InputTextarea;
				break;
			case 'wysiwyg':
				Input = InputWysiwyg;
				break;
			case 'captcha':
				Input = InputCaptcha;
				break;
			case 'hidden':
				Input = InputHidden;
				break;
			default:
				Input = InputText;
				break;
		}

		return (
			<Input {...inputProps} ref={vm.input} />
		);
	}
}

FormInput.defaultProps = {
	className: '',
	type: "text",
	name: undefined,
	validation: false,
	multiple: false,
	value: '',
	label: '',
	popLabel: false,
	hideAsterisk: false,
	formInput: true,
	touchOnBlur: false,
	hideError: false,
	noValidClass: false,
};

class InputText extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			value: props.value,
			error: false,
			errorMessage: false,
			touched: false,
			validation: this.calculateValidation(),
		}

		this._mounted = false;
		this.cleaveInstance = false;

		this.input = React.createRef();
		this.handleChange = this.handleChange.bind(this);
		this.handleBlur = this.handleBlur.bind(this);
		this.reset = this.reset.bind(this);
		this.calculateValidation = this.calculateValidation.bind(this);
	}

	componentDidMount() {
		this._mounted = true;

		this.props.onChange({
			errorMessage: this.state.errorMessage,
			error: this.state.error,
			name: this.props.name,
			touched: this.state.touched,
			value: this.state.value,
			validation: this.state.validation,
		});

		this.validate();

		// window.format = formatNumber;
	}

	componentWillUnmount() {
		this._mounted = false;
	}

	componentDidUpdate(prevProps, prevState) {
		//let vm = this;
		if (!isEqual(prevProps.validation, this.props.validation)) {
			this.setState({ validation: this.calculateValidation() })
		}
		if (prevProps.value !== this.props.value) {
			this.setState({ value: this.props.value });
		}

		if (prevState.value !== this.state.value || !isEqual(prevState.validation, this.state.validation)) {
			this.validate(this.state.value);
		}

		if (prevState.value !== this.state.value || prevState.touched !== this.state.touched || prevState.error !== this.state.error) {

			this.props.onChange({
				errorMessage: this.state.errorMessage,
				error: this.state.error,
				name: this.props.name,
				touched: this.state.touched,
				value: this.state.value,
				validation: this.state.validation,
			});

		}
	}

	calculateValidation() {
		let validateProp = this.props.validation;
		if (this.props.type === 'email' && validateProp === true) {
			validateProp = ['required', 'email'];
		}
		return validateProp;
	}

	handleChange(e) {
		let vm = this;

		if(e.persist) {
			e.persist();
		}
		let newVal = e.target.value;

		if(vm.props.slug) {
			newVal = newVal.replace(/\s/g, '');
		}

		this.setState({ value: newVal });
	}

	handleBlur(e) {
		let vm = this;
		e.persist();
		let maskPrefix = e.target.getAttribute('data-removable-mask-prefix');
		let newVal = e.target.value;

		if(maskPrefix && newVal === maskPrefix) {
			newVal = '';
			setTimeout(() => {
				if(vm._mounted) {
					vm.setState({ value: '', touched: (vm.props.touchOnBlur ? true : vm.state.touched) });
					e.target.value = '';
					vm.cleaveInstance.lastInputValue = '';
					vm.cleaveInstance.state.value = '';
				}
			}, 10);
		}

		vm.setState({ value: newVal, touched: (vm.props.touchOnBlur ? true : vm.state.touched) });
	}

	validate(value = this.state.value) {
		let vm = this;
		let validStatus = validation(value, vm.state.validation);
		let currentValidation = vm.state.errorMessage;

		vm.setState({ error: (validStatus !== false), errorMessage: validStatus });

		if (vm.state.validation.compare && !isEqual(validStatus, currentValidation)) {
			setTimeout(function () {
				if (vm._mounted && vm.props.onFeedback) {
					vm.props.onFeedback('validateAll');
				}
			}, 20);
		}
	}

	reset() {
		this.setState({ value: '', touched: false });
	}

	render() {
		let vm = this;
		const [numberRegex, numberInputMode] = (vm.props.decimals && vm.props.decimals > 0 ? [/\d*/, 'decimal'] : [/\d*/, 'decimal']);

		let Elem = 'input';

		let labelText = false;

		let props = {
			...omit(vm.props, ['onChange', 'innerContent', 'placeholder', 'value', 'popLabel', 'validation', 'touched', 'className', 'hideError', 'icon', 'hideAsterisk', 'onFeedback', 'touchOnBlur', 'slug', 'decimals']),
			onChange: vm.handleChange,
			onBlur: vm.handleBlur,
			value: vm.state.value ? vm.state.value : "",
			placeholder: (vm.props.placeholder ? vm.props.placeholder : undefined),
			ref: vm.input,
			className: 'inputwrap-input',
		};

		if (props.type === 'number') {
			Elem = Cleave;
			props.options = {
				numeral: true,
				delimiter: '',
			}
			props.type = 'text';

			// props.pattern = (vm.props.decimals && vm.props.decimals > 0 ? '[0-9]+([.,][0-9]{0,'+vm.props.decimals+'})?$' : '[0-9]+');
			props.pattern = numberRegex;
			props.inputMode = numberInputMode;
		}
		else if (props.type === 'phone') {
			props.mask = 'phone';
			props.inputMode = 'tel';
		}
		else if (props.type === 'ip') {
			props.type = 'text';
			props.pattern = '[0-9.]+';
			props.inputMode = 'decimal';
			props.onChange = (e) => {
				e.persist();

				if (e.target.value === '' || /^(?!\.)([0-9.]+)$/.test(e.target.value)){
					let synthEvent = {...e};
					vm.handleChange(synthEvent);
				}
			}
		}
		else if (props.type === 'email') {
			props.inputMode = 'email'
		}

		if (props.mask) {
			Elem = Cleave;

			props.options = vm.props.options ? vm.props.options : {};

			if(vm.props.type === 'number') {
				props.options.numeral = true;
				props.options.delimiter = '';
				props['data-parse']="number";
			}

			if(props.mask === 'phone') {
				props['data-parse']="phone";
				props.options = {
					//prefix: '+90 ',
					phone: true,
    				phoneRegionCode: 'TR',
    				delimiter: ' ',
					...props.options,
				}
			}
			else if(props.mask === 'number') {
				props.pattern = numberRegex;
				props.inputMode = numberInputMode;

				props.options = {
					numeral: true,
					numeralDecimalMark: ',',
					delimiter: '.',
					numeralThousandsGroupStyle: 'thousand',
					numeralDecimalScale: vm.props.decimals ? vm.props.decimals : 0,
					...props.options,
				}

				props['data-parse-decimal-mark'] = props.options.numeralDecimalMark;
			}
			else if(props.mask === 'numeric') {
				props.pattern = numberRegex;
				props.inputMode = numberInputMode;

				props.options = {
					numericOnly: true,
					numeralDecimalMark: ',',
					delimiter: '.',
					numeralThousandsGroupStyle: 'thousand',
					numeralDecimalScale: vm.props.decimals ? vm.props.decimals : 0,
					...props.options,
				}

				props['data-parse-decimal-mark'] = props.options.numeralDecimalMark;
			}
			else if(props.mask === 'iban') {
				props.pattern = numberRegex;
				props.inputMode = numberInputMode;

				props.options = {
					numericOnly: true,
					prefix: 'TR',
					delimiter: ' ',
					blocks: [4, 4, 4, 4, 4, 4, 2],
					noImmediatePrefix: true,
					...props.options,
				}

				props.onInit = (e) => { vm.cleaveInstance = e; }

				props['data-removable-mask-prefix'] = 'TR';
			}
			else if(props.mask === 'creditCard') {
				props.pattern = /\d*/
				props.inputMode = 'decimal';

				props.options = {
					...props.options,
					creditCard: true,
				}
			}
			else if(props.mask === 'expiry') {
				props.pattern = /\d*/;
				props.inputMode = 'decimal';

				props.options = {
					...props.options,
					date: true,
					datePattern: ['m', 'y']
				}
			}
			else {
				props.options = {
					...props.options,
					...props.mask
				};
			}

			delete props.mask;
		}

		if (vm.props.label || (vm.props.popLabel && (vm.props.label || vm.props.placeholder))) {
			labelText = (vm.props.label ? vm.props.label : vm.props.placeholder);
		}

		return (
			<div className={vm.props.className}>
				<div className={'input-outerwrap' + (labelText ? '' : ' no-label')}>
					{vm.props.icon &&
						<i className={"input-icon icon-" + vm.props.icon}></i>
					}
					{labelText &&
						<label className="input-label" htmlFor={vm.props.id}>
							<div className="label-text">
								{labelText}
								{((vm.state.validation !== false && vm.state.validation.required) && !vm.props.hideAsterisk) && <span className="label-asterisk">*</span>}
							</div>
							{vm.props.labelNth && <span className="label-nth">{vm.props.labelNth[0]+'/'+vm.props.labelNth[1]}</span>}
						</label>
					}
					<div className="input-innerwrap">
						{vm.props.innerContent ? vm.props.innerContent : false}
						<Elem {...props} />
					</div>
				</div>
				{vm.props.touched && vm.state.error && vm.props.hideError === false ? (
					<div className="input-error">
						{vm.state.errorMessage}
					</div>
				) : null}
			</div>
		)
	}
}

class InputTextarea extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			value: props.value,
			error: false,
			errorMessage: false,
			touched: false,
			rows: props.rows ? parseInt(props.rows) : 1,
			validation: this.calculateValidation(),
		}

		this.handleChange = this.handleChange.bind(this);
		this.handleBlur = this.handleBlur.bind(this);
		this.reset = this.reset.bind(this);
		this.calculateValidation = this.calculateValidation.bind(this);
	}

	componentDidMount() {
		this.validate();

		this.props.onChange({
			errorMessage: this.state.errorMessage,
			error: this.state.error,
			name: this.props.name,
			touched: this.state.touched,
			value: this.state.value,
			validation: this.state.validation,
		});
	}

	componentDidUpdate(prevProps, prevState) {
		if (!isEqual(prevProps.validation, this.props.validation)) {
			this.setState({ validation: this.calculateValidation() })
		}
		if (prevProps.value !== this.props.value) {
			this.setState({ value: this.props.value });
		}

		if (prevState.value !== this.state.value || !isEqual(prevState.validation, this.state.validation)) {
			this.validate(this.state.value);
		}

		if (prevState.value !== this.state.value || prevState.touched !== this.state.touched || prevState.error !== this.state.error) {

			this.props.onChange({
				errorMessage: this.state.errorMessage,
				error: this.state.error,
				name: this.props.name,
				touched: this.state.touched,
				value: this.state.value,
				validation: this.state.validation,
			});

		}
	}

	calculateValidation() {
		let validateProp = this.props.validation;
		if (this.props.type === 'email' && validateProp === true) {
			validateProp = ['required', 'email'];
		}
		return validateProp;
	}

	handleChange(e) {
		e.persist();
		let minRows = (this.props.rows ? this.props.rows : 1);
		e.target.rows = minRows
		let innerHeight = e.target.scrollHeight - parseFloat(window.getComputedStyle(e.target, null).getPropertyValue('padding-top')) - parseFloat(window.getComputedStyle(e.target, null).getPropertyValue('padding-bottom'));

		let rows = Math.round(pxToRem(innerHeight) / 2);

		let propRows = rows;
		if(propRows > 10) { propRows = 10; }
		else if(propRows < minRows) { propRows = minRows; }

		e.target.rows = propRows;

		this.setState({ value: e.target.value, rows: propRows });
	}

	handleBlur(e) {
		e.persist();
		this.setState({ value: e.target.value, touched: this.props.touchOnBlur ? true : this.state.touched });
	}

	reset() {
		this.setState({ value: '', touched: false });
	}

	validate(value = this.state.value) {
		let validStatus = validation(value, this.state.validation);
		this.setState({ error: (validStatus !== false), errorMessage: validStatus });
	}

	render() {
		let vm = this;

		let labelText = false;

		let props = {
			...omit(vm.props, ['onChange', 'innerContent', 'value', 'popLabel', 'validation', 'touched', 'className', 'hideError', 'hideAsterisk', 'onFeedback', 'touchOnBlur']),
			onChange: vm.handleChange,
			onBlur: vm.handleBlur,
			value: vm.state.value ? vm.state.value : "",
			rows: vm.state.rows,
			className: 'inputwrap-input',
		};

		if (vm.props.label || (vm.props.popLabel && (vm.props.label || vm.props.placeholder))) {
			labelText = (vm.props.label ? vm.props.label : vm.props.placeholder);
		}

		return (
			<div className={vm.props.className}>
				<div className={'input-outerwrap' + (labelText ? '' : ' no-label')}>
					{labelText &&
						<label className="input-label" htmlFor={vm.props.id}>
							<div className="label-text">
								{labelText}
								{((vm.state.validation !== false && vm.state.validation.required) && !vm.props.hideAsterisk) && <span className="label-asterisk">*</span>}
							</div>
							{vm.props.labelNth &&
								<span className="label-nth">{vm.props.labelNth[0]+'/'+vm.props.labelNth[1]}</span>
							}
						</label>
					}
					<div className="input-innerwrap">
						{vm.props.innerContent ? vm.props.innerContent : false}
						<textarea {...props}>
							{this.state.value}
						</textarea>
					</div>
				</div>
				{vm.props.touched && vm.state.error && vm.props.hideError === false ? (
					<div className="input-error">
						{vm.state.errorMessage}
					</div>
				) : null}
			</div>
		)
	}
}

const SourceOption = ({ onToggleSourceMode }) => {
	return (
		<div className="rdw-inline-wrapper">
			<div className="rdw-option-wrapper" title="Show Source" onClick={onToggleSourceMode}>
				<img
					src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDEwIDguMjUiPjxwYXRoIGZpbGw9IiMwMDAiIGQ9Ik0xLC44OGExLDEsMCwwLDAtMSwxdjVBMSwxLDAsMCwwLDEsOEgzLjY2bC0uMjkuNTZIMi44NGEuMy4zLDAsMCwwLS4yNy4zMi4yOC4yOCwwLDAsMCwuMy4yN0g3LjEzYS4yOC4yOCwwLDAsMCwuMy0uMjguMjkuMjksMCwwLDAtLjI4LS4zMUg2LjYzTDYuMzQsOEg5YTEsMSwwLDAsMCwxLTF2LTVhMSwxLDAsMCwwLTEtMVptMCwuNTlIOWEuNDMuNDMsMCwwLDEsLjQ0LjQ0VjYuMDlILjU5VjEuOTFBLjQzLjQzLDAsMCwxLDEsMS40N1ptNC4zMy42YS4zLjMsMCwwLDAtLjI3LjIyTDQuMzQsNS4xMWEuMjkuMjksMCwxLDAsLjU3LjE1aDBsLjc1LTIuODJhLjMuMywwLDAsMC0uMi0uMzZabS0xLjY5LjI0YS4zMy4zMywwLDAsMC0uMjIuMTFsLTEsMS4xN2EuMy4zLDAsMCwwLDAsLjM4bDEsMS4xNmEuMjkuMjksMCwxLDAsLjQ1LS4zOGgwbC0uODMtMSwuODMtMWEuMy4zLDAsMCwwLDAtLjQxQS4yOC4yOCwwLDAsMCwzLjY3LDIuMzFabTIuNjUsMGEuMzEuMzEsMCwwLDAtLjI5LjMuMzIuMzIsMCwwLDAsLjA3LjE5bC44MywxLS44MywxYS4zMS4zMSwwLDAsMCwwLC40Mi4zLjMsMCwwLDAsLjQxLDBoMEw3LjU0LDRhLjMuMywwLDAsMCwwLS4zOGwtMS0xLjE3QS4yOC4yOCwwLDAsMCw2LjMyLDIuMzFaTS41OSw2LjY3SDkuNDF2LjI3QS40My40MywwLDAsMSw5LDcuMzhIMWEuNDMuNDMsMCwwLDEtLjQ0LS40NFpNNC4zMiw4SDUuNjhMNiw4LjUzSDRaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIC0wLjg4KSIvPjwvc3ZnPg==" alt="</>" />
		</div>
		</div>
	)
}

class InputWysiwyg extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			editorState: this.processEditorState(props.value),
			value: props.value,
			error: false,
			errorMessage: false,
			touched: false,
			validation: this.calculateValidation(),
			sourceMode: false,
		}

		this.handleChange = this.handleChange.bind(this);
		this.handleBlur = this.handleBlur.bind(this);
		this.reset = this.reset.bind(this);
		this.calculateValidation = this.calculateValidation.bind(this);
		this.toggleSourceMode = this.toggleSourceMode.bind(this);
	}

	componentDidMount() {
		this.validate();

		this.props.onChange({
			errorMessage: this.state.errorMessage,
			error: this.state.error,
			name: this.props.name,
			touched: this.state.touched,
			value: this.state.value,
			validation: this.state.validation,
		});
	}

	componentDidUpdate(prevProps, prevState) {
		if (!isEqual(prevProps.validation, this.props.validation)) {
			this.setState({ validation: this.calculateValidation() })
		}
		if (prevProps.value !== this.props.value && this.props.value !== this.state.value) {
			this.setState({
				value: this.props.value,
				editorState: this.processEditorState(this.props.value),
			});
		}

		if (prevState.value !== this.state.value || !isEqual(prevState.validation, this.state.validation)) {
			this.validate(this.state.value);
		}

		if (prevState.value !== this.state.value || prevState.touched !== this.state.touched || prevState.error !== this.state.error) {

			this.props.onChange({
				errorMessage: this.state.errorMessage,
				error: this.state.error,
				name: this.props.name,
				touched: this.state.touched,
				value: this.state.value,
				validation: this.state.validation,
			});

		}
	}

	toggleSourceMode() {
		this.setState({ sourceMode: !this.state.sourceMode })
	}

	processEditorState(value) {
		const contentState = stateFromHTML(value || '')
		return EditorState.createWithContent(contentState)
	}

	calculateValidation() {
		let validateProp = this.props.validation;
		if (this.props.type === 'email' && validateProp === true) {
			validateProp = ['required', 'email'];
		}
		return validateProp;
	}

	handleChange(newState) {
		this.setState({
			editorState: newState,
			value: draftToHtml(convertToRaw(newState.getCurrentContent())),
		})
	}

	handleBlur(e) {
		e.persist();
		this.setState({ touched: this.props.touchOnBlur ? true : this.state.touched });
	}

	reset() {
		this.setState({ value: '',  touched: false });
	}

	validate(value = this.state.value) {
		let validStatus = validation(value, this.state.validation);
		this.setState({ error: (validStatus !== false), errorMessage: validStatus });
	}

	render() {
		let vm = this;

		let labelText = false;

		let props = {
			...omit(vm.props, ['onChange', 'innerContent', 'value', 'popLabel', 'validation', 'touched', 'className', 'hideError', 'hideAsterisk', 'onFeedback', 'touchOnBlur']),
			onBlur: vm.handleBlur,
			wrapperClassName: 'inputwrap-input',
			editorState: vm.state.editorState,
			onEditorStateChange: vm.handleChange,
			toolbar: {
				options: ['inline', 'blockType', 'fontSize', 'list', 'textAlign', 'history'],
			},
			toolbarCustomButtons: [<SourceOption onToggleSourceMode={this.toggleSourceMode} />]
		};

		if (vm.props.label || (vm.props.popLabel && (vm.props.label || vm.props.placeholder))) {
			labelText = (vm.props.label ? vm.props.label : vm.props.placeholder);
		}

		return (
			<div className={vm.props.className}>
				<div className={'input-outerwrap' + (labelText ? '' : ' no-label')}>
					{labelText &&
						<label className="input-label" htmlFor={vm.props.id}>
							<div className="label-text">
								{labelText}
								{((vm.state.validation !== false && vm.state.validation.required) && !vm.props.hideAsterisk) && <span className="label-asterisk">*</span>}
							</div>
							{vm.props.labelNth &&
								<span className="label-nth">{vm.props.labelNth[0]+'/'+vm.props.labelNth[1]}</span>
							}
						</label>
					}
					<div className="input-innerwrap">
						{vm.props.innerContent ? vm.props.innerContent : false}
						{vm.state.sourceMode ?
							<div className="inputwrap-input rdw-editor-wrapper">
								<div className="rdw-editor-toolbar">
									<SourceOption onToggleSourceMode={this.toggleSourceMode} />
								</div>
								<textarea
									className="public-DraftEditorPlaceholder-root rdw-editor-sourceinput"
									value={vm.state.value}
									onChange={(e) => {
										vm.setState({
											value: e.target.value,
											editorState: vm.processEditorState(e.target.value),
										});
									}}/>
							</div>
							:
							<Editor
								{...props} />
						}
					</div>
				</div>
				{vm.props.touched && vm.state.error && vm.props.hideError === false ? (
					<div className="input-error">
						{vm.state.errorMessage}
					</div>
				) : null}
			</div>
		)
	}
}

class InputFile extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			value: props.value,
			fileNames: '',
			files: [],
			error: false,
			errorMessage: false,
			validation: props.validation,
		}

		this.input = React.createRef();
		this.handleChange = this.handleChange.bind(this);
		this.reset = this.reset.bind(this);
	}

	handleChange(e) {
		let vm = this;
		let fileNames = '';
		let files = [];

		for (let k = 0; k < vm.input.current.files.length; k++) {
			if (k > 0) { fileNames += ', '; }
			fileNames += vm.input.current.files[k].name;
			files.push(vm.input.current.files[k]);
		}

		vm.setState({ fileNames: fileNames, files: files })
		vm.validate(vm.input.current.files, vm.input.current.value, true);
	}

	// reset() {
	// 	this.input.current.value = "";
	// 	this.handleChange();
	// }

	componentDidMount() {
		this.validate(this.input.current.files, this.input.current.value, false);
	}

	validate(files = false, value = false, touch) {
		let vm = this;
		if(files === false) { files = vm.input.current.files }
		if(value === false) { value = vm.input.current.value }

		let validStatus = validation(files, vm.state.validation);
		vm.setState({ error: (validStatus !== false), errorMessage: validStatus });
		vm.props.onChange({
			errorMessage: validStatus,
			error: (validStatus !== false),
			name: this.props.name,
			touched: touch,
			value: value,
			validation: this.state.validation,
		});
	}

	reset() {
		this.input.current.value = "";
		this.setState({ value: '', fileNames: '', files: [], touched: false });
		this.validate(this.input.current.files, this.input.current.value, false);
	}

	render() {
		let vm = this;

		let labelText = false;
		if (vm.props.label || vm.props.placeholder) {
			labelText = (vm.props.label ? vm.props.label : (vm.props.placeholder ? vm.props.placeholder : ''));
		}

		let className = vm.props.className;

		let ContainerTag = vm.state.files.length ? 'div' : 'label';

		if(vm.props.hideEmpty) { className += ' hide-empty'; }

		return (
			<div className={className}>
				<div className={'input-outerwrap' + (labelText ? '' : ' no-label')}>
					{labelText &&
						<label className="input-label" htmlFor={vm.props.id}>
							<div className="label-text">
								{labelText}
							</div>
							{vm.props.labelNth &&
								<span className="label-nth">{vm.props.labelNth[0]+'/'+vm.props.labelNth[1]}</span>
							}
						</label>
					}
					<div className="input-innerwrap">
						{vm.props.innerContent ? vm.props.innerContent : false}
						<i className="input-icon icon-attachment"></i>
						<input
							className="inputwrap-input"
							ref={this.input}
							name={vm.props.name}
							onChange={vm.handleChange}
							type="file"
							id={vm.props.id}
							multiple={vm.props.multiple}
						/>
						<ContainerTag className="file-container" {...(vm.state.files.length ? {} : {htmlFor: vm.props.id})}>
							{vm.state.files.length === 0 ?
								<React.Fragment>
									<i className="container-addicon icon-plus"></i>
									{(vm.props.placeholder ? vm.props.placeholder + ((vm.props.validation !== false) ? ' *' : '') : 'Bir dosya seçin')}
								</React.Fragment>
							:
								<React.Fragment>
									{vm.state.files.map((file, nth) => (
										<div className="container-file" key={nth}>
											{file.name}
										</div>
									))}
									<button className="container-remove" type="button" onClick={() => { this.reset() }}>
										Temizle <i className="icon-close" />
									</button>
								</React.Fragment>
							}
						</ContainerTag>
					</div>
				</div>
				{vm.props.touched && vm.state.error && vm.props.hideError === false ? (
					<div className="input-error">
						{vm.state.errorMessage}
					</div>
				) : null}
			</div>
		)
	}
}

class InputSelect extends React.Component {
	constructor(props) {
		super(props);

		this.input = React.createRef();
		this.handleChange = this.handleChange.bind(this);
		this.validate = this.validate.bind(this);

		this.state = {
			value: (props.value ? props.value : null),
			labelText: (props.value ? props.value : (props.placeholder ? props.placeholder : null)),
			error: false,
			errorMessage: false,
		}
	}

	componentDidMount() {
		this.validate(this.state.value);
	}

	componentDidUpdate(prevProps, prevState) {
		if (!isEqual(prevProps.value, this.props.value)) {
			this.setState({ value: this.props.value });
		}

		if (!isEqual(prevProps.options, this.props.options)) {
			this.setState({ value: this.props.value });
		}

		if (!isEqual(this.state.value, prevState.value)){
			this.validate();
		}

		if (
			(!this.state.value && this.props.defaultValue) ||
			(!isEqual(this.props.defaultValue, prevProps.defaultValue) && !this.props.value)
		) {
			this.setState({ value: this.props.defaultValue });
		}
	}

	handleChange(option) {
		let vm = this;
		vm.validate(option, true);
	}

	validate(option, touch = false) {
		let vm = this;

		if (option === undefined) { option = vm.state.value; }

		let optVal = option;
		if(optVal) {
			if(Array.isArray(option)){
				optVal = [];
				for(const item of option) {
					optVal.push(item.value);
				}
				optVal = optVal.join(', ');
			}
			else {
				optVal = option.value;
			}
		}
		else {
			optVal = '';
		}

		let validStatus = validation(optVal, vm.props.validation);

		vm.props.onChange({
			value: option,//(option ? option.value : (vm.state.value ? vm.state.value.value : null)),
			name: this.props.name,
			errorMessage: validStatus,
			error: (validStatus !== false),
			touched: touch,
			validation: vm.props.validation,
		});

		vm.setState({ value: option, error: (validStatus !== false), errorMessage: validStatus });

		if (vm.props.value === false && option) {
			vm.validate(false, false);
		}
	}

	reset() {
		this.setState({ value: null, touched: false });
	}

	render() {
		let vm = this;

		let labelText = false;

		if (vm.props.label || (vm.props.popLabel && (vm.props.label || vm.props.placeholder))) {
			labelText = (vm.props.label ? vm.props.label : vm.props.placeholder);
		}

		let props = {
			...omit(vm.props, ['onChange', 'innerContent', 'placeholder', 'value', 'popLabel', 'validation', 'touched', 'className', 'hideError', 'onFeedback', 'elemClass']),
			onChange: vm.handleChange,
			value: vm.state.value,
			placeholder: vm.props.placeholder,
			className: vm.props.elemClass ? vm.props.elemClass : undefined,
		};

		return (
			<div className={vm.props.className} id={vm.props.wrapperId || ''}>
				<div className={'input-outerwrap' + (labelText ? '' : ' no-label')}>
					{labelText &&
						<label className="input-label" htmlFor={vm.props.id}>
							<div className="label-text">
								{labelText}
								{((vm.props.validation !== false && vm.props.validation.required) && !vm.props.hideAsterisk) && <span className="label-asterisk">*</span>}
							</div>
							{vm.props.labelNth &&
								<span className="label-nth">{vm.props.labelNth[0]+'/'+vm.props.labelNth[1]}</span>
							}
						</label>
					}
					<div className="input-innerwrap">
						{vm.props.innerContent ? vm.props.innerContent : false}
						<Select {...props} />
					</div>
				</div>
				{vm.props.touched && vm.state.error && vm.props.hideError === false ? (
					<div className="input-error">
						{vm.state.errorMessage}
					</div>
				) : null}
			</div>
		)
	}
}

class InputCheck extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			value: props.value,
			checked: (props.checked ? true : false),
			error: false,
			errorMessage: false,
		}

		this.input = React.createRef();
		this.handleChange = this.handleChange.bind(this);
	}

	componentDidMount() {
		this.validate(this.state.checked, false);
	}

	componentDidUpdate(prevProps, prevState) {
		if(prevProps.checked !== this.props.checked) {
			this.validate(this.props.checked, false);
		}
	}

	handleChange(e) {
		if(this.props.readOnly) {
			e.preventDefault();
		}
		else {
			this.validate(e.target.checked, true);
		}
	}

	validate(checked, touch) {
		let vm = this;
		if (checked === undefined) { checked = vm.state.checked; }
		let checkValue = (checked ? vm.props.value : '');
		let validStatus = validation((checked ? '1' : ''), vm.props.validation);
		vm.setState({ value: checkValue, checked: checked, error: (validStatus !== false), errorMessage: validStatus });
		vm.props.onChange({
			errorMessage: validStatus,
			error: (validStatus !== false),
			name: this.props.name,
			touched: touch,
			value: checkValue,
			validation: this.props.validation,
		});
	}

	reset() {
		this.setState({ value: this.props.value, checked: (this.props.checked ? true : false), touched: false });
	}

	render() {
		let vm = this;

		let inputProps = {
			name: (vm.props.name ? vm.props.name : undefined),
			type: "checkbox",
			onChange: vm.handleChange,
			value: vm.state.value,
			id: vm.props.id,
			checked: (vm.state.checked ? true : false),
			disabled: vm.props.disabled,
			readOnly: vm.props.readOnly,
			tabIndex: vm.props.tabIndex ? vm.props.tabIndex : undefined,
			//className: 'inputwrap-input',
		}

		return (
			<div className={vm.props.className}>
				<div className="input-outerwrap">
					<div className="input-opts input-innerwrap">
						{vm.props.innerContent ? vm.props.innerContent : false}
						<div className="checkwrap">
							<input
								{...inputProps}
							/>
							<label htmlFor={vm.props.id} className={vm.props.labelClass}>
								<span className="label-check"></span>
								<span className="label-content">
									{vm.props.label ? vm.props.label : (vm.props.children ? vm.props.children : false)}
								</span>
							</label>
						</div>
					</div>
				</div>
				{vm.props.touched && vm.state.error && vm.props.hideError === false ? (
					<div className="input-error">
						{vm.state.errorMessage}
					</div>
				) : null}
			</div>
		)
	}
}

class InputCheckGroup extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			value: props.value ? props.value : [],
		}

		this._mounted = false;

		this.input = React.createRef();
		this.handleChange = this.handleChange.bind(this);
		this.reset = this.reset.bind(this);
	}

	componentDidMount() {
		this._mounted = true;
		this.validate(this.state.value, false);
	}

	componentWillUnmount() {
		this._mounted = false;
	}

	componentDidUpdate(prevProps, prevState){
		if(prevState.value !== this.state.value){
			this.validate(this.state.value, false);
		}
	}

	handleChange(e, opt){
		let vm = this;
		e.persist();
		let newVal = vm.state.value.slice(0);

		if(e.target.checked) {
			if(!newVal.includes(opt.value)){
				newVal.push(opt.value);
			}
		}
		else {
			newVal.splice(newVal.indexOf(opt.value), 1);
		}

		vm.setState({value: newVal});

		if (opt.onChange) {
			setTimeout(function () {
				if(vm._mounted) {
					opt.onChange(e);
				}
			}, 10);
		}
	}

	validate(value, touch) {
		let vm = this;
		if (value === undefined) { value = vm.state.value; }
		let validStatus = validation(value, vm.props.validation);
		vm.setState({ error: (validStatus !== false), errorMessage: validStatus });

		vm.props.onChange({
			errorMessage: validStatus,
			error: (validStatus !== false),
			name: vm.props.name,
			touched: touch,
			value: value,
			validation: vm.props.validation,
		});
	}

	reset() {
		let val = this.props.value ? this.props.value : false;
		this.setState({value: val});
		this.validate(val, false);
	}

	render(){
		let vm = this;
		let props = this.props;

		return (
			<div className={props.className}>
				<div className="input-outerwrap">
					{props.label &&
						<label className="input-label">
							<div className="label-text">{props.label}</div>
							{props.labelNth &&
								<span className="label-nth">{props.labelNth[0]+'/'+props.labelNth[1]}</span>
							}
						</label>
					}

					<div className="input-opts input-innerwrap">
						{vm.props.innerContent ? vm.props.innerContent : false}
						{props.options.map((option, nth) => (
							<div className="checkwrap" key={nth}>
								<input
									disabled={props.disabled || option.disabled}
									name={props.name+'[]'}
									type="checkbox"
									onChange={(e) => { vm.handleChange(e, option)}}
									value={option.value}
									checked={this.state.value.indexOf(option.value) > -1}
									id={'checkwrap_'+props.name+'_'+nth}
									//className="inputwrap-input"
								/>
								<label htmlFor={'checkwrap_' + props.name + '_' + nth} className={option.labelClass}>
									<span className="label-check"></span>
									<span className="label-content">
										{option.label}
									</span>
								</label>
							</div>
						))}
					</div>
				</div>
				{props.touched && vm.state.error && vm.props.hideError === false ? (
					<div className="input-error">
						{vm.state.errorMessage}
					</div>
				) : null}
			</div>
		)
	}
}

class InputRadio extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			value: props.value ? props.value : false,
		}

		this.input = React.createRef();
		this.handleChange = this.handleChange.bind(this);
		this.reset = this.reset.bind(this);
	}

	componentDidMount() {
		this.validate(this.state.value, false);
	}

	componentDidUpdate(prevProps, prevState){
		if(prevState.value !== this.state.value){
			this.validate(this.state.value, false);
		}
		if(prevProps.value !== this.props.value){
			this.setState({ value: this.props.value })
		}
	}

	handleChange(e, value){
		let vm = this;
		e.persist();
		vm.setState({value: value});
	}

	validate(value, touch) {
		let vm = this;
		if (value === undefined) { value = vm.state.value; }
		let validStatus = validation(value, vm.props.validation);
		vm.setState({ error: (validStatus !== false), errorMessage: validStatus });

		vm.props.onChange({
			errorMessage: validStatus,
			error: (validStatus !== false),
			name: vm.props.name,
			touched: touch,
			value: value,
			validation: vm.props.validation,
		});
	}

	reset() {
		let val = this.props.value ? this.props.value : false;
		this.setState({value: val});
		this.validate(val, false);
	}

	render(){
		let vm = this;
		let props = this.props;

		return (

			<div className={props.className}>
				<div className={'input-outerwrap' + (props.label ? '' : ' no-label')}>
					{props.label &&
						<label className="input-label">
							<div className="label-text">{props.label}</div>
							{props.labelNth &&
								<span className="label-nth">{props.labelNth[0]+'/'+props.labelNth[1]}</span>
							}
						</label>
					}

					<div className="input-opts input-innerwrap">
						{vm.props.innerContent ? vm.props.innerContent : false}
						{props.options.map((option, nth) => (
							<div className="checkwrap" key={nth}>
								<input
									disabled={props.disabled || option.disabled}
									name={props.name}
									type="radio"
									onChange={(e) => vm.handleChange(e, option.value)}
									value={option.value}
									checked={typeof option.checked === 'boolean' ? option.checked : (option.value === this.state.value)}
									id={'checkwrap_'+props.name+'_'+nth}
									//className="inputwrap-input"
								/>
								<label htmlFor={'checkwrap_' + props.name + '_' + nth} className={option.labelClass}>
									<span className="label-check"></span>
									<span className="label-content">
										{option.label}
									</span>
									{/*props.block ?
										<React.Fragment>
											{option.icon && <i className={"label-icon icon-" + option.icon}></i>}
											<span className="label-text">{option.label}</span>
										</React.Fragment>
										:
										<React.Fragment>
											<span className="label-check"></span>
											<span className="label-content">
												{option.label}
											</span>
										</React.Fragment>
									*/}
								</label>
							</div>
						))}
					</div>
				</div>

				{(props.touched && vm.state.error && vm.props.hideError === false) ? (
					<div className="input-error">
						{vm.state.errorMessage}
					</div>
				) : null}
			</div>
		)
	}
}

class InputCaptcha extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			value: '',
			error: false,
			errorMessage: false,
		}

		this.input = React.createRef();
		this.reset = this.reset.bind(this);

		this.handleChange = this.handleChange.bind(this);
	}

	handleChange(newVal) {
		this.setState({ value: newVal });
	}

	componentDidMount() {
		this.validate(this.state.value, false);
	}

	componentDidUpdate(prevProps, prevState) {
		if(prevState.value !== this.state.value) {
			this.validate(this.state.value, true);
		}
		if(!isEqual(prevProps.validation, this.props.validation)) {
			this.validate(this.state.value, true);
		}
	}

	validate(value, touch) {
		let vm = this;
		if(value === undefined) { value = vm.state.value; }
		let validStatus = validation(value, vm.props.validation);
		vm.setState({ value: value, error: (validStatus !== false), errorMessage: validStatus });
		
		vm.props.onChange({
			errorMessage: validStatus,
			error: (validStatus !== false),
			name: this.props.name,
			touched: touch,
			value: value,
			validation: this.props.validation,
		});
	}

	reset() {
		this.setState({ value: this.props.value, touched: false });
	}

	render() {
		let inputProps = pick(this.props, ['theme', 'tabindex', 'stoken', 'hl', 'size', 'badge', 'captchaType']);

		if(inputProps.captchaType) {
			inputProps.type = inputProps.captchaType;
		}

		return (
			<div className={this.props.className}>
				<div className="input-outerwrap no-label">
					<div className="input-innerwrap">
						<ReCAPTCHA
							sitekey={config.captchaSiteKey}
							onChange={this.handleChange}
							onExpired={() => { this.handleChange(''); }}
							onErrored={() => { this.handleChange(''); }}
							hl="tr"
							{...inputProps}
							/>
					</div>
				</div>
				{this.props.touched && this.state.error && this.props.hideError === false ? (
					<div className="input-error">
						{this.state.errorMessage}
					</div>
				) : null}
			</div>
		)
	}
}

class InputHidden extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			value: props.value,
			error: false,
			errorMessage: false,
		}

		this.input = React.createRef();
		this.reset = this.reset.bind(this);
	}

	componentDidMount() {
		this.validate(this.state.value, false);
	}

	componentDidUpdate(prevProps, prevState) {
		if(prevProps.value !== this.props.value) {
			this.validate(this.props.value, true);
		}
		if(!isEqual(prevProps.validation, this.props.validation)) {
			this.validate(this.props.value, true);
		}
	}

	validate(value, touch) {
		let vm = this;
		if(value === undefined) { value = vm.state.value; }
		let validStatus = validation(value, vm.props.validation);
		vm.setState({ value: value, error: (validStatus !== false), errorMessage: validStatus });
		
		vm.props.onChange({
			errorMessage: validStatus,
			error: (validStatus !== false),
			name: this.props.name,
			touched: touch,
			value: value,
			validation: this.props.validation,
		});
	}

	reset() {
		this.setState({ value: this.props.value, touched: false });
	}

	render() {
		let vm = this;

		let inputProps = {
			name: (vm.props.name ? vm.props.name : undefined),
			value: vm.state.value ? vm.state.value : '',
			id: vm.props.id,
		}

		return (
			<input
				type="hidden"
				{...inputProps}
			/>
		)
	}
}

class InputDate extends React.Component {
	constructor(props) {
		super(props);

		let validateProp = props.validation;
		if (validateProp === true) {
			validateProp = ['required', 'date'];
		}

		this.state = {
			value: props.value,
			error: false,
			errorMessage: false,
			validation: validateProp
		}

		this.handleChange = this.handleChange.bind(this);
		this.reset = this.reset.bind(this);
	}

	componentDidMount() {
		this.validate(this.state.value, false);
	}

	componentDidUpdate(prevProps, prevState) {
		if(prevProps.value !== this.props.value) {
			this.validate(this.props.value, true);
		}
		if(!isEqual(prevProps.validation, this.props.validation)) {
			this.validate(this.props.value, true);
		}
	}

	reset() {
		let val = this.props.value ? this.props.value : false;
		this.setState({value: val});
		this.validate(val, false);
	}

	handleChange(value) {
		this.validate(value, true);
	}

	validate(value, touch) {
		let vm = this;
		if(value === undefined) { value = vm.state.value; }
		let validStatus = validation(value, vm.state.validation);
		vm.setState({ value: value, error: (validStatus !== false), errorMessage: validStatus });
		vm.props.onChange({
			errorMessage: validStatus,
			error: (validStatus !== false),
			touched: touch,
			value: value,
		});
	}

	render() {
		let vm = this;

		let labelText = false;
		if (vm.props.label || vm.props.placeholder) {
			labelText = (vm.props.label ? vm.props.label : vm.props.placeholder);
		}

		let props = {
			...omit(vm.props, ['onChange', 'innerContent', 'placeholder', 'value', 'popLabel', 'validation', 'touched', 'className', 'hideError', 'onFeedback', 'hideAsterisk', 'type', 'label', 'multiple', 'touchOnBlur']),
			onChange: vm.handleChange,
			value: vm.state.value,
			placeholder: vm.props.placeholder,
			className: vm.props.elemClass ? vm.props.elemClass : undefined,
		};

		return (
			<div className={vm.props.className}>
				<div className={'input-outerwrap' + (labelText ? '' : ' no-label')}>
					{vm.props.icon &&
						<i className={"input-icon icon-" + vm.props.icon}></i>
					}
					{(labelText && !props.plain) &&
						<label className="input-label" htmlFor={vm.props.id}>
							<div className="label-text">
								{labelText}
								{((vm.state.validation !== false && vm.state.validation.required) && !vm.props.hideAsterisk) && <span className="label-asterisk">*</span>}
							</div>
							{vm.props.labelNth && <span className="label-nth">{vm.props.labelNth[0]+'/'+vm.props.labelNth[1]}</span>}
						</label>
					}
					<div className="input-innerwrap">
						{vm.props.innerContent ? vm.props.innerContent : false}
						<DatePicker
							placeholder={vm.props.placeholder + ((vm.props.placeholder && vm.props.validation !== false) ? ' *' : '')}
							{...props}
						/>
					</div>
				</div>
				{vm.props.touched && vm.state.error && vm.props.hideError === false ? (
					<div className="input-error">
						{vm.state.errorMessage}
					</div>
				) : null}
			</div>
		)
	}
}

//// Form Itself

export class InputForm extends React.Component {
	constructor(props) {
		super(props);

		this.validationCount = 0;
		this.state = {
			forceTouch: false
		}

		this.reset = this.reset.bind(this);
		this.submit = this.submit.bind(this);
		this.validate = this.validate.bind(this);
		this.elementStateChange = this.elementStateChange.bind(this);
		this.elementFeedback = this.elementFeedback.bind(this);
		this.setForceTouch = this.setForceTouch.bind(this);

		this.elems = [];
		this.validElements = [];
		this.invalidElements = [];
		this.errorMessages = {}
		this.elemNames = [];

		this.form = React.createRef();
	}

	elementStateChange(state) {
		if (state.error && state.validation !== false && state.validation !== undefined) {
			this.validElements = pull(this.validElements, state.name);
			this.invalidElements = union(this.invalidElements, [state.name]);

			if(this.errorMessages[state.name] !== state.errorMessage){
				this.errorMessages[state.name] = state.errorMessage;

				if(this.props.onValidationChange && this.state.forceTouch) {
					this.props.onValidationChange(this.errorMessages);
				}
			}
		}
		else if ((state.validation !== false && state.validation !== undefined) || (!(state.validation === false || state.validation === undefined) && this.invalidElements.includes(state.name))) {
			this.invalidElements = pull(this.invalidElements, state.name);
			this.validElements = union(this.validElements, [state.name]);
			if(this.errorMessages[state.name]){
				this.errorMessages = omit(this.errorMessages, [state.name])
				//delete this.errorMessages[state.name];

				if(this.props.onValidationChange && this.state.forceTouch) {
					this.props.onValidationChange(this.errorMessages);
				}
			}
		}

		// Touch Event
		if (this.props.onTouch) {
			if (this.validElements.length < this.validationCount && state.touched) {
				this.props.onTouch();
			}
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if(this.state.forceTouch && !prevState.forceTouch && this.props.onValidationChange){
			this.props.onValidationChange(this.errorMessages);
		}
	}

	elementFeedback(event) {
		switch (event) {
			case "validateAll":
				this.validateChildren();
				break;
			default: break;
		}
	}

	validateChildren() {
		this.elems.forEach(function (elem, nth) {
			if (elem !== null) {
				elem.validate(undefined, true);
			}
		});
	}

	validate() {
		this.validateChildren();
		return (this.validElements.length >= this.validationCount);
	}

	setForceTouch(status) {
		this.setState({ forceTouch: status });
	}

	calculateValidationStatus() {
	}

	serialize() {
		return (
			this.props.serializeAsForm ?
			serializeForm(this.form.current)
			:
			serializeObject(this.form.current, {
				parseBool: this.props.parseBool,
				ignoreEmpty: this.props.ignoreEmpty,
			})
			);
	}

	submit(e = false) {
		if (e) { e.preventDefault(); e.persist(); }
		
		this.setState({ forceTouch: true })
		
		if (this.props.onTouch) {
			this.props.onTouch();
		}

		if (this.validate()) {
			this.setState({ sending: true });

			if (this.props.onSubmit) {
				if(this.props.serialize) {
					this.serialize().then((formData) => {
						this.props.onSubmit(formData, e ? e.nativeEvent : false);
					})
				}
				else {
					this.props.onSubmit(this.form.current, e ? e.nativeEvent : false);
				}
			}
		}
		else {
			if (this.props.onValidationError) {
				this.props.onValidationError(this.errorMessages);
			}
		}
	}

	reset() {
		//let inputs = this.form.current.querySelector('input, textarea');
		/*for(let k = 0; k < inputs.length; k++){
			let input = inputs[k];
			if(input.getAttribute('type'))
		}*/

		//let children = React.Children.toArray(this.props.children);
		let elemLength = this.elems.length;
		for (let k = 0; k < elemLength; k++) {
			let elem = this.elems[k];
			if (elem) {
				elem.reset();
			}
		}
		this.setState({ forceTouch: false })
	}

	modifyChildren(children, props) {
		this.elements = false;
		return React.Children.map(children, child => {
			if (child !== null) {
				if (!child.props || child.props.innerForm) {
					return child
				}
				if (child.props.formInput /*child.props.name && child.props.type !== "hidden"*/) {
					if(child.props.name){
						if(!child.props.name.endsWith('[]') && this.elemNames.indexOf(child.props.name) > -1){
							console.warn('Uyarı, form içinde aynı isimli ("'+ child.props.name +'") birden çok input var.');
						}
						this.elemNames.push(child.props.name);
					}

					if (child.props.validation !== false) {
						this.validationCount++;
					}
					let clone = React.cloneElement(child, props);
					return clone;
				}
				if (child.props.children) {
					return React.cloneElement(child, {
						children: this.modifyChildren(child.props.children, props),
					});
				}
				else {
					return child;
				}
			}
		})
	}

	render() {
		let vm = this;
		let Container = vm.props.tag;
		vm.validationCount = 0;
		vm.elemNames = [];
		vm.elems = [];

		return (
			<Container
				className={'form ' + vm.props.className}
				onSubmit={vm.submit}
				noValidate
				autoComplete={vm.props.autoComplete || ''}
				ref={this.form}>
				{
					vm.modifyChildren(vm.props.children, {
						onChangeInForm: vm.elementStateChange,
						onFeedback: vm.elementFeedback,
						forceTouch: vm.state.forceTouch,
						formRef: function (ref) { vm.elems.push(ref) },
					})
				}
			</Container>
		)
	}
}

InputForm.defaultProps = {
	className: '',
	tag: 'form',
	serialize: true,
	serializeAsForm: false,
	parseBool: true,
	ignoreEmpty: false,
	serializeOpts: {},
	onSubmit: function () { console.warn('Form submitted without handler.'); },
};